module.exports = __webpack_public_path__ + "static/img/29.4e70361a.png";